import React, { useMemo } from "react";
import { useI18nMessage } from "@lookiero/i18n-react";
import { Button } from "@lookiero/sty-psp-ui";
import { NextBestActionType } from "../../../../../../projection/nextBestActionDefinition/nextBestActionDefinition";
import { NextBestActionItem } from "../../../../components/nextBestActionItem/NextBestActionItem";
import { DOMAIN } from "../../../../i18n/i18n";
import { useNextBestAction } from "../../behaviours/useNextBestAction";
import { style as nextBestActionCtaStyle } from "./NextBestActionCta.style";

const NextBestActionCta: NextBestActionItem<NextBestActionType.CTA> = ({ action }) => {
  const { onPressCta } = useNextBestAction();

  const style = useMemo(() => nextBestActionCtaStyle(), []);

  const text = useI18nMessage({
    domain: DOMAIN,
    id: action.translationKey,
  });

  return (
    <Button style={{ button: style.button }} testID="next-best-action-cta" onPress={onPressCta}>
      {text}
    </Button>
  );
};

export { NextBestActionCta };
